import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { compact } from 'lodash';
import { useMutation } from '@apollo/client/react';
import {
  BudgetCalculatorDocument,
  FinancingDocument,
  type BudgetCalculatorInput,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';
import requireValue from 'utils/requireValue';

const useBudgetCalculator = () => {
  const [budgetCalculatorMutation] = useMutation(BudgetCalculatorDocument);
  const { id: projectId } = useParams<{ id?: string }>();
  const { locale } = useIntl();

  const budgetCalculator = useCallback(
    async (formData: BudgetCalculatorInput, step?: number | null) => {
      try {
        const refetchQueries = [
          projectId ? { query: FinancingDocument, variables: { id: projectId } } : null,
        ];

        const res = await budgetCalculatorMutation({
          variables: { projectId, formData, step, locale, ...(projectId ? { projectId } : {}) },
          refetchQueries: compact(refetchQueries),
          awaitRefetchQueries: true,
        });
        const { budgetCalculator: result } = requireValue(res.data, 'budgetCalculator');

        return result;
      } catch (error) {
        throw withRaw(toGraphqlError(error), error || '');
      }
    },
    [budgetCalculatorMutation, projectId, locale],
  );
  return budgetCalculator;
};

export default useBudgetCalculator;
